import type { CircleLayer } from 'react-map-gl';

const MarkersStrokeHoverLayer: CircleLayer = {
  id: "markers-stroke",
  type: "circle",
  paint: {
    "circle-radius": 10,
    "circle-opacity": 0,
    "circle-color": "transparent",
    "circle-stroke-color": "white",
    "circle-stroke-opacity": 1,
    "circle-stroke-width": 4
  }
};

export { MarkersStrokeHoverLayer }
